import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormGroup, ButtonGroup, Button } from 'reactstrap';
import map from 'lodash/map';

class ButtonGroupField extends Component {
  static propTypes = {
    input: PropTypes.object.isRequired,
    inputProps: PropTypes.object,
    meta: PropTypes.object,
    error: PropTypes.string,
    className: PropTypes.string,
    data: PropTypes.arrayOf(PropTypes.shape({
      value: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
    })).isRequired,
    onBlur: PropTypes.func.isRequired,
  }

  renderOption(option) {
    return (
      <Button
        className="w-100"
        key={option.value}
        onClick={() => this.props.input.onChange(option.value)}
        outline={this.props.input.value != option.value}
        color={this.props.input.value == option.value ? 'primary' : 'light'}
      >
        {option.text}
      </Button>
    );
  }

  render() {
    return (
      <FormGroup row>
        <div className="col-12">
          <ButtonGroup className="d-flex">
            {map(this.props.data, (option) => this.renderOption(option))}
          </ButtonGroup>
        </div>
      </FormGroup>
    );
  }
}

const wrapper = (props, error, componentProps) => (
  <ButtonGroupField {...props} {...componentProps} className={componentProps.className} />
);

export default wrapper;



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/forms/ButtonGroupField.jsx